module.exports = __webpack_public_path__ + "static/media/default.c8b61d5d.jfif";